import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Search, Users } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import { BlogFooter } from "../blog/BlogPages";
import { api } from "../rsvp/api";
import "../blog/blog.css";
import "../styles/EventsPage.css";
import "../styles/Communities.css";

/** /communities: the public Blox communities, each opening its posts. */
const CommunitiesPage = () => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    document.title = "Communities · Blox";
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const { data } = await api.publicCommunities(1, search);
        setItems(data?.communities || []);
        setError(false);
      } catch (e) {
        console.error("Couldn't load communities:", e);
        setError(true);
      }
    }, search ? 300 : 0);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <main className="blog-page">
      <SiteHeader />
      <section className="blog-hero">
        <p className="blog-eyebrow">Find your people</p>
        <h1>Communities</h1>
        <p className="blog-lede">Groups for the things you love, from football to food. See what people are talking about.</p>
        <label className="communities-search">
          <Search size={17} />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search communities" aria-label="Search communities" />
        </label>
      </section>

      <section className="blog-list" aria-live="polite">
        {error ? (
          <p className="events-empty">We couldn't load communities right now. Please refresh in a moment.</p>
        ) : items === null ? (
          <div className="blog-grid">{[0, 1, 2].map((i) => <div key={i} className="blog-card events-skeleton" />)}</div>
        ) : items.length === 0 ? (
          <p className="events-empty">{search ? "No community matches that search." : "No public communities yet. Check back soon."}</p>
        ) : (
          <div className="blog-grid">
            {items.map((c, i) => (
              <Link to={`/communities/${c.id}`} className="blog-card" key={c.id} style={{ animationDelay: `${i * 60}ms` }}>
                <div className="events-banner">
                  {c.cover ? <img src={c.cover} alt="" loading="lazy" /> : <span aria-hidden="true">🫂</span>}
                </div>
                <div className="blog-card-body">
                  <h3>{c.name}</h3>
                  {c.description && <p className="communities-desc">{c.description}</p>}
                  <p className="events-fact"><Users size={15} /> {c.members} {c.members === 1 ? "member" : "members"}</p>
                  <p className="events-fact"><MessageSquare size={15} /> {c.posts} {c.posts === 1 ? "post" : "posts"}</p>
                  <span className="blog-read events-cta">See posts →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
      <BlogFooter />
    </main>
  );
};

export default CommunitiesPage;
